import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as MapActions from '../map/map.action';
import { IMaps } from 'src/app/models/map';
import { Constants } from 'src/app/helper/constants';

@Injectable()
export class MapEffects {
    constructor(private http: HttpClient, private action$: Actions) { }

    private ApiURL = Constants.GET_MAP_URL;

    GetMaps$: Observable<Action> = createEffect(() =>
        this.action$.pipe(
            ofType(MapActions.GetMapsApiAction),
            switchMap(action =>
                this.http.get(this.ApiURL).pipe(
                    map((data: IMaps) => {
                        return MapActions.SuccessGetMapsApiAction({ mapObject: data });
                    }),
                    catchError((error: Error) => {
                        return of(MapActions.ErrorGetMapsApiAction(error));
                    })
                )
            )
        )
    );
}
